import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import { useContext, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import SelectComponent from 'components/SelectComponent';
import { FieldValues, useController, useForm } from 'react-hook-form';
import FilterContext from '../Filter/FilterContext';
import { SelectFilter as SelectFilterInterface } from './types';

interface Props extends Partial<Omit<SelectFilterInterface, 'filterType'>> {
    filterKey: string;
    callback?: () => void;
    size?: 'xs' | 'md';
    // Volle Spaltenbreite statt fixer 400px (Formular-Kontext)
    fullWidth?: boolean;
}

export const SelectFilter = ({ filterName, filterKey, callback, size = 'xs', fullWidth = false, options }: Props) => {
    const [filter, setFilter] = useContext(FilterContext);
    const { handleSubmit, control, reset } = useForm({ defaultValues: { [filterKey]: filter?.[filterKey] } });
    const {
        field: { onChange, value }
    } = useController({ control, name: `${filterKey}.value` });

    useEffect(() => {
        reset({ [filterKey]: filter?.[filterKey] });
    }, [filter, filterKey, reset]);

    const handleSubmitFilter = (data: FieldValues) => {
        setFilter({ ...filter, ...data });
        callback?.();
    };

    const resetFilter = () => {
        setFilter({ ...filter, [filterKey]: undefined });
        callback?.();
    };

    return (
        <form onSubmit={handleSubmit(handleSubmitFilter)}>
            <div
                className="tw-flex tw-items-baseline tw-gap-6 tw-px-2"
                style={{ minWidth: fullWidth || size !== 'xs' ? '100%' : 400 }}
            >
                {filterName && (
                    <b className="tw-w-[30%] tw-shrink-0 tw-truncate tw-text-sm">{filterName}</b>
                )}
                <SelectComponent options={options} onChange={onChange} value={value} buttonProps={{ size: 'xs' }} />
                <div className="tw-flex tw-gap-2">
                    <Button type="button" color="error" auto size={size} onPress={resetFilter}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                    <Button type="submit" color={filter?.[filterKey] ? 'warning' : 'success'} auto size={size}>
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                </div>
            </div>
        </form>
    );
};
